module.exports = __webpack_public_path__ + "static/media/news-times-union-cdphp.83bc5a49.jpg";